/**
 * TNWS product cards — secondary image hover only within a centered inset zone.
 */
(function () {
  const ACTIVE_CLASS = 'is-tnws-hover-zone-active';

  function readInset(section, edge) {
    if (!section) return null;
    const value = getComputedStyle(section).getPropertyValue(`--tnws-card-hover-zone-${edge}`).trim();
    if (!value.endsWith('%')) return null;
    return parseFloat(value) / 100;
  }

  function isInsideZone(event, media) {
    const section = media.closest('.section-tnws-featured-products');
    const top = readInset(section, 'top') ?? 0.22;
    const right = readInset(section, 'right') ?? 0.2;
    const bottom = readInset(section, 'bottom') ?? 0.16;
    const left = readInset(section, 'left') ?? 0.18;
    const rect = media.getBoundingClientRect();
    if (!rect.width || !rect.height) return false;

    const x = (event.clientX - rect.left) / rect.width;
    const y = (event.clientY - rect.top) / rect.height;

    return x >= left && x <= 1 - right && y >= top && y <= 1 - bottom;
  }

  function bindCardWrapper(wrapper) {
    const media = wrapper.querySelector('.media.media--tnws-zone-hover');
    if (!media || wrapper.dataset.tnwsZoneHoverBound === 'true') return;
    wrapper.dataset.tnwsZoneHoverBound = 'true';

    const updateZone = (event) => {
      media.classList.toggle(ACTIVE_CLASS, isInsideZone(event, media));
    };

    /* Card link overlay sits above the image — listen on the wrapper, not .media */
    wrapper.addEventListener('mousemove', updateZone);
    wrapper.addEventListener('mouseleave', () => {
      media.classList.remove(ACTIVE_CLASS);
    });
  }

  function init() {
    if (!window.matchMedia('(hover: hover)').matches) return;

    document.querySelectorAll('.product-card-wrapper').forEach((wrapper) => {
      if (wrapper.querySelector('.media.media--tnws-zone-hover')) {
        bindCardWrapper(wrapper);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
